import { useTranslation } from 'react-i18next';

import { IceCream } from './Illustrations/IceCream';
import { StatusPage } from './StatusPage';

export const UnknownError = () => {
	const { t } = useTranslation('monarch');

	return (
		<StatusPage
			graphic={<IceCream title={t('status.mistake_image_title')} />}
			heading={t('status.unknown_title')}
			subheading={t('status.unknown_description')}
		/>
	);
};
